<div class="modal-container">
  <div class="modal">
    <div class="modal-header">
      <div class="modal-title">New version released <span *ngIf="version">({{version}})</span></div>
    </div>
    <div class="modal-body">
      <div class="info-message">We are always working hard to make Polarix the best way to create, localise, use and track your SCP. As such we have released a new update which contains patches, fixes and enhancements. Click the Reload button to get the latest release{{preventReload ? '' : '.'}} <span *ngIf="preventReload">or click the Postpone button to display this message again in 1 minute.</span></div>
      <div class="form-elements text-right">
        <app-centrui-button *ngIf="preventReload" (click)="close(false)" [type]="'button'" [size]="'medium'" [style]="'secondary'" [text]="'Postpone'"></app-centrui-button>&nbsp;
        <app-centrui-button (click)="close(true)" [type]="'button'" [size]="'medium'" [style]="'primary'" [text]="'Reload'"></app-centrui-button>&nbsp;
      </div>
    </div>
  </div>
</div>
